import React from 'react';
import { motion } from 'framer-motion';

const riseData = [
  {
    id: 1,
    title: "Rise for a more equal world",
    desc: "We embed sustainability to our client work and operate our business with a strong commitment to the environment, ethics and human rights. We work to create value in communities around the world.",
    bgImage: "/assets/diversity/img2.png",
    gridClass: "md:col-span-6"
  },
  {
    id: 2,
    title: "Rise to be future-ready",
    desc: "We anticipate emerging global trends and rapidly adapt our technological capabilities to build resilient, long-term operational infrastructure for our partners.",
    bgImage: "/assets/diversity/img3.png",
    gridClass: "md:col-span-6"
  },
  {
    id: 3,
    title: "Rise to create value",
    desc: "Our business processes are architected to unlock non-linear financial growth while strictly maintaining maximum resource efficiency and material circularity.",
    bgImage: "/assets/diversity/img4.png",
    gridClass: "md:col-span-12 h-[260px] sm:h-[320px]"
  }
];

const MobikodeRiseSection = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.12 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  return (
    <section className="w-full bg-[#FFFFFF] pb-16 lg:pb-24 overflow-hidden select-none text-left relative z-50">
      <div className="max-w-[1440px] w-full mx-auto px-[20px] lg:px-[80px]">

        <div className="w-full mb-10 lg:mb-14">
          <h2 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] tracking-tight font-sora leading-tight max-w-[850px]">
            Mobikode is intentionally diverse and globally inclusive. intentionally diverse and globally inclusive.
          </h2>
          <p className="text-[#49577A] text-[14px] sm:text-[16px] font-graphik font-[500] mt-4 leading-relaxed">
            Its diversity, equity, and inclusion (DEI) philosophy aligns with the Mahindra Group's brand motto, "Together, we Rise."
          </p>
        </div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
          className="grid grid-cols-1 md:grid-cols-12 gap-6 xl:gap-8 w-full items-stretch"
        >
          {riseData.map((item) => (
            <motion.div
              key={item.id}
              variants={itemVariants}
              whileHover={{ y: -4 }}
              transition={{ duration: 0.3 }}
              className={`w-full min-h-[280px] sm:min-h-[340px] ${item.gridClass} bg-[#020a1e] relative overflow-hidden rounded-none cursor-pointer group flex flex-col justify-end p-6 sm:p-8 xl:p-10`}
            >
              <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-700 ease-out group-hover:scale-103 opacity-90"
                style={{ backgroundImage: `url('${item.bgImage}')` }}
              />

              <div className="absolute inset-x-0 bottom-0 h-0 transition-all duration-500 ease-out group-hover:h-full z-10 opacity-95" />

              <div className="w-full flex flex-col items-start relative z-20">
                <h3 className="text-white font-[600] font-sora text-[16px] sm:text-[20px] tracking-tight leading-snug mb-3 transition-transform duration-500 group-hover:-translate-y-2">
                  {item.title}
                </h3>

                <p className="text-white text-[14px] font-graphik sm:text-[16px] leading-relaxed font-[500] opacity-0 max-h-0 overflow-hidden transition-all duration-500 ease-out group-hover:opacity-100 group-hover:max-h-48 group-hover:mt-2">
                  {item.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
};

export default MobikodeRiseSection;